module.exports = require("@bechtel/client-assets/dist/images/empty_state_weld_photo.svg");